module.exports = __webpack_public_path__ + "static/media/13n.68b96a79.png";